import React from 'react'
import ApiTokensTable from './TokensTable'

const ApiTokensMain = () => {
  return <ApiTokensTable />
}

export {ApiTokensMain}
